import { MiniMonth } from './MiniMonth';
import { LanguageFilter } from './LanguageFilter';
import { TeacherFilter } from './TeacherFilter';
import { CalendarActivityPanel } from './CalendarActivityPanel';

/**
 * Barra lateral: navegación por mes, actividades, maestros (director/dev) e idiomas.
 */
export const CalendarSidebar = ({
    date,
    onDateChange,
    calendarView = 'week',
    markedDayKeys,
    eventDates = [],
    summary,
    taskGroups = { pending: [], upcoming: [] },
    showUpcoming = false,
    canViewTasks,
    showTeacherFilter = false,
    languageOptions,
    selectedLanguageIds,
    onToggleLanguage,
    onClearLanguages,
    teacherOptions = [],
    selectedTeacherIds = [],
    onToggleTeacher,
    onClearTeachers,
    focusedEventId,
    onSelectTaskEvent,
}) => (
    <aside className="w-full min-w-0 lg:w-auto flex flex-col gap-4">
        <MiniMonth
            value={date}
            onChange={onDateChange}
            markedDayKeys={markedDayKeys}
            eventDates={eventDates}
        />

        <CalendarActivityPanel
            calendarView={calendarView}
            summary={summary}
            taskGroups={taskGroups}
            showUpcoming={showUpcoming}
            canViewTasks={canViewTasks}
            focusedEventId={focusedEventId}
            onSelectTaskEvent={onSelectTaskEvent}
        />

        {showTeacherFilter && (
            <TeacherFilter
                teacherOptions={teacherOptions}
                selectedTeacherIds={selectedTeacherIds}
                onToggleTeacher={onToggleTeacher}
                onClearTeachers={onClearTeachers}
            />
        )}

        <LanguageFilter
            languageOptions={languageOptions}
            selectedLanguageIds={selectedLanguageIds}
            onToggleLanguage={onToggleLanguage}
            onClearLanguages={onClearLanguages}
        />
    </aside>
);
